<template>
  <div
    class="shadow-modal relative z-1010 flex min-h-9 items-center gap-1 rounded-lg px-4 py-1"
    :class="{
      'bg-snackbar-bgr-primary-rest text-snackbar-fgr-primary-rest': !message.error,
      'bg-snackbar-bgr-critical-rest text-snackbar-fgr-critical-rest': message.error,
      'pe-1! [p]:me-5': (message.actions && message.actions.length) || message.dismissible,
    }"
  >
    <p class="text-body-default max-w-120">{{ message.text }}</p>
    <Button
      v-for="(action, index) in message.actions"
      :key="index"
      :variant="variant"
      :icon-only="!!action.icon && !action.text"
      @click.prevent.stop="action.handler"
    >
      <Icon v-if="action.icon" :src="action.icon" />
      <span v-else>{{ action.text }}</span>
    </Button>
    <Button v-if="message.dismissible" :variant="variant" icon-only @click.prevent.stop="dismissClick">
      <Icon src="X" />
    </Button>
    <div
      v-if="message.count && message.count > 1"
      class="bg-bgr-critical-primary text-fgr-white absolute -top-2.5 -right-2.5 grid place-content-center rounded-full text-xs transition-[width,height]"
      :class="message.count < 10 ? 'size-5' : 'size-6'"
    >
      {{ count }}
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { Action, IToast } from "~/types/toast";

  const {
    message = {
      actions: [] as Action[],
      count: 0,
      duration: 5000,
      dismissible: false,
      group: "",
      icon: undefined,
      id: undefined,
      target: null,
      text: "",
      error: false,
    },
  } = defineProps<{ message?: IToast }>();
  const emit = defineEmits(["dismiss"]);
  let timeout: NodeJS.Timeout | null = null;

  const setMessageTimeout = () => {
    if (message.duration === 0) return;
    timeout = setTimeout(dismiss, message.duration);
  };

  onMounted(() => {
    setMessageTimeout();
  });

  watch(
    () => message.count,
    (v) => {
      if (v === 1) return false;
      clearTimeout(timeout!);
      setMessageTimeout();
    }
  );
  const dismissClick = () => {
    if (!message.dismissible) return;
    if (timeout) clearTimeout(timeout);
    dismiss();
  };
  const dismiss = () => {
    emit("dismiss", message);
  };

  const count = computed(() => {
    if (!message.count) return;

    const c = message.count;
    if (c > 99) return `99+`;

    return c;
  });

  const variant = computed(() => {
    return message.error ? ButtonVariant.ActionCritical : ButtonVariant.ActionPrimary;
  });
</script>
